export default __webpack_public_path__ + "static/media/Paolo Rumiz.ed61867e.jpg";